"use client";

import * as React from "react";
import { OTPInput, OTPInputContext } from "input-otp";

import { tw } from "@/utils";

const InputOTP = React.forwardRef<
  React.ElementRef<typeof OTPInput>,
  React.ComponentPropsWithoutRef<typeof OTPInput>
>(({ className, containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    containerClassName={tw(
      "flex items-center gap-2 has-[:disabled]:opacity-50",
      containerClassName,
    )}
    className={tw("disabled:cursor-not-allowed", className)}
    {...props}
  />
));
InputOTP.displayName = "InputOTP";

const InputOTPGroup = React.forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={tw("flex w-full justify-center gap-x-4", className)}
    {...props}
  />
));
InputOTPGroup.displayName = "InputOTPGroup";

const InputOTPSlot = React.forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div"> & { index: number; hasError: boolean }
>(({ index, className, hasError, ...props }, ref) => {
  const inputOTPContext = React.useContext(OTPInputContext);
  const slot = inputOTPContext.slots[index];

  if (!slot) {
    return null;
  }

  const { char, isActive } = slot;
  return (
    <div
      ref={ref}
      className={tw(
        "relative flex size-14 items-center justify-center rounded-lg border border-neutral-200 shadow-sm transition-all",
        isActive && "ring-ring z-10 ring-1",
        hasError && "border-error-700",
        className,
      )}
      {...props}
    >
      {char ?? <span className="select-none">-</span>}
    </div>
  );
});
InputOTPSlot.displayName = "InputOTPSlot";

export { InputOTP, InputOTPGroup, InputOTPSlot };
